import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';
import { createDiffUtil } from 'store/util/diff';

const selectCustomMapState = (state: RootState) => state.customMap.data;
const selectRoofDataState = (state: RootState) => state.roofData.data;
// state selector

const selectCustomMap = createSelector(
	[selectCustomMapState, selectRoofDataState],
	(state, roofstate) => {

		const { groundMetersPerPixel } = roofstate;

		const customMaps = state.customMaps.map(m => ({
			...m,
			metersPerPixel: m.metersPerPixel ?? groundMetersPerPixel
		})).sort((a, b) => a.sortOrder - b.sortOrder);

		return ({
			...state,
			selectedMap: customMaps.find((m) => m.id === state.editingMapId),
			customMaps,
		});
	});

// Diff---

const RESETTABLE_CUSTOM_MAP_KEYS = [
	'metersPerPixel',
	'x',
	'y',
	'scaleX',
	'scaleY',
	'rotation',
	'opacity',
	'isVisible',
] as const satisfies readonly (keyof DesignCustomMap)[];

const customMapDiff = createDiffUtil<DesignCustomMap>(
	RESETTABLE_CUSTOM_MAP_KEYS
);

const selectHasCustomMapChanges = createSelector(
	[selectCustomMapState],
	(customMapState) => {
		if (!customMapState.editingMapId) return false;
		const selectedMap = customMapState.customMaps.find(m => m.id === customMapState.editingMapId);
		const baselineMap = customMapState.baselineSelectedMap;

		// console.log('baseline', baselineMap);
		// console.log('selctedMap', selectedMap);
		if (!selectedMap || !baselineMap) return false;
		return customMapDiff.hasChanges(selectedMap, baselineMap);
	}
);

export {
	RESETTABLE_CUSTOM_MAP_KEYS,
	selectHasCustomMapChanges,
	selectCustomMap,
};
